import "../../styles/style"
import "../../cell/style"
import "../../popup/style"
import "../index.scss"
